import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';
import { FC } from 'react';

type Props = {
	isMobile?: boolean;
};

const EActivitiesElementSkeleton: FC<Props> = ({ isMobile }) => {
	return (
		<article
			className={cn(
				'px-6 py-4 flex items-center gap-4 hover:bg-popover-50',
				isMobile && 'px-4',
			)}>
			<div className={`size-8 flex items-center justify-center`}>
				<Skeleton className='size-5 rounded-full' />
			</div>
			<div className='grow'>
				<div className='h-6 flex items-center'>
					<Skeleton className='h-3 w-50 rounded-full' />
				</div>
				<div className='h-5 flex items-center'>
					<Skeleton className='h-3 w-16 rounded-full' />
				</div>
			</div>
			<Skeleton className='h-3 w-10 rounded-full' />
		</article>
	);
};

export default EActivitiesElementSkeleton;
